/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { Component } from "react";
import PropTypes from "prop-types";

import { Prompt } from "react-router-dom";
import Alert from "./Alert";
import getHistory from "../helpers/getHistory";
import messages from "../helpers/messages";

const defaultState = () => ({
  modalOpen: false,
  lastLocation: null,
  confirmedNavigation: false
});

class NavigationBlocker extends Component {
  state = defaultState();

  showModal = location => {
    this.setState({
      modalOpen: true,
      lastLocation: location
    });
  };

  closeModal = callback => {
    this.setState(
      {
        modalOpen: false
      },
      callback
    );
  };

  handleBlockedNavigation = nextLocation => {
    if (
      !this.props.safeRoutes.some(r => nextLocation.pathname.indexOf(r) !== -1)
    ) {
      const { confirmedNavigation } = this.state;
      if (!confirmedNavigation) {
        this.showModal(nextLocation);
        return ""; //This calls getUserConfirmation
      }
      return true;
    }
  };

  handleConfirmNavigationClick = () => {
    const history = getHistory();
    this.closeModal(() => {
      const { lastLocation } = this.state;
      if (lastLocation) {
        this.props.onExit && this.props.onExit();
        this.setState(defaultState(), () => {
          history.resolveBlock(true);
        });
      }
    });
  };

  handleModalClose = () => this.setState({ modalOpen: false });

  render() {
    const { when } = this.props;
    const { modalOpen } = this.state;
    return (
      <>
        <Prompt when={when} message={this.handleBlockedNavigation} />
        <Alert
          open={modalOpen}
          message={messages.navigationBlockerMessage.defaultMessage}
          title={messages.confirmNavigation.defaultMessage}
          singleButton={false}
          primaryButtonCaption={messages.exit.defaultMessage}
          secondaryButtonCaption={messages.stay.defaultMessage}
          handlePrimaryButtonClick={this.handleConfirmNavigationClick}
          handleSecondaryButtonClick={this.handleModalClose}
          handleClose={this.handleModalClose}
        />
      </>
    );
  }
}

NavigationBlocker.propTypes = {
  when: PropTypes.bool.isRequired
};

NavigationBlocker.defaultProps = {
  safeRoutes: []
};

export default NavigationBlocker;
